import { Context, Schema } from "effect";

export class WidgetCustomer extends Schema.Class<WidgetCustomer>(
  "WidgetCustomer",
)({ _id: Schema.String, email: Schema.String }) {}

/**
 * The widget context for a single request, resolved by `WidgetPublic`
 * middleware. Always contains the team (resolved from the `x-widget-id`
 * header). The optional `customer` is populated when the request carries a
 * valid `Authorization: Bearer <customerWidgetAuth JWT>` header for this
 * team — handlers can read `widget.customer` to attribute conversation /
 * message writes without manually re-resolving the bearer token.
 */
export class WidgetTeam extends Schema.Class<WidgetTeam>("WidgetTeam")({
  _id: Schema.String,
  name: Schema.String,
  createdAt: Schema.Date,
  customer: Schema.optional(WidgetCustomer),
}) {}

export class CurrentWidget extends Context.Tag("CurrentWidget")<
  CurrentWidget,
  WidgetTeam
>() {}

export class WidgetAuthContext extends Schema.Class<WidgetAuthContext>(
  "WidgetAuthContext",
)({ team: WidgetTeam, customer: WidgetCustomer }) {}

export class CurrentWidgetCustomer extends Context.Tag("CurrentWidgetCustomer")<
  CurrentWidgetCustomer,
  WidgetAuthContext
>() {}
